export const REPLACE_KEYS = {
  DESTINATION: '[destino]',
  USER: '[usuario]',
  LOCATION_NAME: '[nombre ubicación]',
  REPORT_NAME: '[nombre del reporte]',
  OLD_PRODUCT_SERIAL: '[serial anterior]',
  NEW_PRODUCT_SERIAL: '[serial nuevo]'
};

export interface IEventsTypesContent {
  [key: string]: {
    title: string;
    subtitle: string;
  };
}

export const EVENTS_TYPES_CONTENT: IEventsTypesContent = {
  // ----- Logistic Service -----
  // Actualizaciones de estado
  '8bd3da52-7410-4858-a4f3-4e4c43748949': {
    title: 'Servicio solicitado',
    subtitle: `Servicio solicitado por ${REPLACE_KEYS.USER}`
  },
  '66900e22-3ead-4a84-b9b6-23ae72b67eb6': {
    title: 'Cotización solicitada',
    subtitle: `Cotización solicitada por ${REPLACE_KEYS.USER}`
  },
  '45a9aedf-9829-4578-93cb-9bb88e0b5477': {
    title: 'Servicio confirmado',
    subtitle: `${REPLACE_KEYS.USER} ha confirmado el servicio`
  },
  '9412fb3d-0e8d-4788-92fa-db0ad2c5464a': {
    title: 'Servicio en proceso',
    subtitle: `${REPLACE_KEYS.USER} cambió el estado del servicio`
  },
  '804d13e7-db21-4d4e-8f55-71f53cbd5150': {
    title: 'Servicio activo',
    subtitle: `${REPLACE_KEYS.USER} cambió el estado del servicio`
  },
  '4f1326c0-0d83-48b5-9717-1dd6c5f67c34': {
    title: 'Servicio entregado',
    subtitle: `${REPLACE_KEYS.USER} cambió el estado del servicio`
  },
  '5d77ef59-f167-4550-b529-9c6e0e3fe8b3': {
    title: 'Servicio cancelado',
    subtitle: `${REPLACE_KEYS.USER} canceló el servicio`
  },
  '97350f60-8e1e-4a25-a9d3-160a5891a933': {
    title: 'Servicio atrasado',
    subtitle: 'El servicio ha superado su fecha estimada de entrega'
  },
  // Pagos y Facturación
  '80323206-808d-4b49-a846-76e08346327b': {
    title: 'Cotización cargada',
    subtitle: `${REPLACE_KEYS.USER} cargó la cotización`
  },
  'f6ca9064-9498-40e3-a25b-e7e4925ba89c': {
    title: 'Link de pago agregado',
    subtitle: `${REPLACE_KEYS.USER} agregó un link de pago manual al servicio`
  },
  'd448cedf-ef2b-4350-82d4-00c56702496e': {
    title: 'Link de pago generado',
    subtitle: 'Stripe generó automáticamente un link de pago para el servicio'
  },
  'd572ada6-f089-49df-b823-ec477bcf1133': {
    title: 'Cotización aprobada',
    subtitle: `${REPLACE_KEYS.USER} aprobó la cotización del servicio`
  },
  'a41ef16a-bf7e-4354-bd5b-d158c5f3cfe1': {
    title: 'Cotización rechazada',
    subtitle: `${REPLACE_KEYS.USER} rechazó la cotización del servicio`
  },
  '9e4891b7-2f2f-4e62-a07e-4680d8efbc5c': {
    title: 'Pago confirmado',
    subtitle: `Pago del servicio confirmado manualmente por ${REPLACE_KEYS.USER}`
  },
  'c1f18020-547f-4950-9e4e-5760fb37222a': {
    title: 'Acuerdo de pago establecido',
    subtitle: `Acuerdo de pago agregado al servicio por ${REPLACE_KEYS.USER}`
  },
  'd5329edd-cc65-4b8b-bad5-57d70e24b728': {
    title: 'Servicio confirmado automáticamente',
    subtitle: 'Care cambió automáticamente el estado del servicio a confirmado'
  },
  '1c0a138f-4e9c-4cb6-aa55-817ff56e1939': {
    title: 'Comprobante cargado',
    subtitle: `Comprobante de pago agregado por ${REPLACE_KEYS.USER}`
  },
  '11bfe061-9a73-4d84-8a1a-1d153e01c5b1': {
    title: 'Servicio confirmado',
    subtitle: 'Servicio confirmado automáticamente por Stripe'
  },
  '78017c7a-8683-49bf-99d9-5517bd58b543': {
    title: 'Fecha de pago actualizada',
    subtitle: `Fecha de pago modificada por ${REPLACE_KEYS.USER}`
  },
  'b2b6135d-481a-4e1f-8f19-74731e1993b2': {
    title: 'Factura actualizada',
    subtitle: `Factura actualizada por ${REPLACE_KEYS.USER}`
  },
  'cf843142-f422-46dd-b448-bc1428772d04': {
    title: 'Factura cargada',
    subtitle: `Factura agregada al servicio por ${REPLACE_KEYS.USER}`
  },
  'a1b2c3d4-5e6f-7a8b-9c0d-1e2f3a4b5c6d': {
    title: 'Servicio confirmado',
    subtitle: 'Servicio confirmado automáticamente con Crédito Bord'
  },
  'b2c3d4e5-6f7a-8b9c-0d1e-2f3a4b5c6d7e': {
    title: 'Cotización aprobada y Servicio confirmado automáticamente',
    subtitle: `${REPLACE_KEYS.USER} aprobó la cotización del servicio con Credito Bord y se pasa a confirmado`
  },
  // Reporte de información
  '7d94aee1-eeac-474b-b75f-e2dab7d03047': {
    title: 'Problema en la dirección de origen',
    subtitle: `${REPLACE_KEYS.USER} reportó un problema con la dirección de origen`
  },
  'c65ca91b-8b2f-45c1-952d-eaa70c7f6906': {
    title: 'Problema con el teléfono de origen',
    subtitle: `${REPLACE_KEYS.USER} reportó un número telefónico inválido de origen`
  },
  'ee78099f-b9c7-4bf6-b6ff-f740ee6f7431': {
    title: 'Información corregida por el usuario',
    subtitle: `${REPLACE_KEYS.USER} corrigió la información reportada para ${REPLACE_KEYS.LOCATION_NAME}`
  },
  '5af35d9e-a24f-4e02-b2ee-d15c9028fc2a': {
    title: 'Información modificada por el usuario',
    subtitle: `${REPLACE_KEYS.USER} realizó cambios en los datos de origen`
  },
  '72e0395a-86e5-4291-b4d9-5162a32943ec': {
    title: 'Información modificada por el usuario',
    subtitle: `${REPLACE_KEYS.USER} realizó cambios en los datos de destino`
  },
  'g4h5i6j7-k8l9-m0n1-p2q3-r4s5t6u7v8w9x': {
    title: 'Información modificada',
    subtitle: `${REPLACE_KEYS.USER} realizó cambios en los datos de origen`
  },
  'h5i6j7k8-l9m0-n1p2-q3r4-s5t6u7v8w9x0y': {
    title: 'Información modificada',
    subtitle: `${REPLACE_KEYS.USER} realizó cambios en los datos de destino`
  },
  '28bb55aa-788b-440c-b8a4-fb72c12560e2': {
    title: 'Sin respuesta de operaciones',
    subtitle: `Han pasado 24 horas sin validación de ${REPLACE_KEYS.USER} tras el cambio realizado por el cliente`
  },
  'c0608ace-26b3-4fbd-a2ae-297f066c7649': {
    title: 'Sin respuesta del usuario',
    subtitle: `Han pasado 24 horas sin respuesta de ${REPLACE_KEYS.USER} al reporte de información`
  },
  'e6f7a8b9-c0d1-2e3f-4a5b-6c7d8e9f0a1b': {
    title: 'Problema en la dirección de destino',
    subtitle: `${REPLACE_KEYS.USER} reportó un problema con la dirección de destino`
  },
  'f7a8b9c0-d1e2-3f4a-5b6c-7d8e9f0a1b2c': {
    title: 'Problema con el teléfono de destino',
    subtitle: `${REPLACE_KEYS.USER} reportó un número telefónico inválido de destino`
  },
  'a8b9c0d1-e2f3-4a5b-6c7d-8e9f0a1b2c3d': {
    title: 'Problema en la ciudad de origen',
    subtitle: `${REPLACE_KEYS.USER} reportó un problema con la ciudad de origen`
  },
  'b9c0d1e2-f3a4-5b6c-7d8e-9f0a1b2c3d4e': {
    title: 'Problema en las indicaciones de origen',
    subtitle: `${REPLACE_KEYS.USER} reportó un problema con las indicaciones de origen`
  },
  'c0d1e2f3-a4b5-6c7d-8e9f-0a1b2c3d4e5f': {
    title: 'Problema en el código postal de origen',
    subtitle: `${REPLACE_KEYS.USER} reportó un problema con el código postal de origen`
  },
  'd1e2f3a4-b5c6-7d8e-9f0a-1b2c3d4e5f6a': {
    title: 'Problema en la ciudad de destino',
    subtitle: `${REPLACE_KEYS.USER} reportó un problema con la ciudad de destino`
  },
  'e2f3a4b5-c6d7-8e9f-0a1b-2c3d4e5f6a7b': {
    title: 'Problema en las indicaciones de destino',
    subtitle: `${REPLACE_KEYS.USER} reportó un problema con las indicaciones de destino`
  },
  'f3a4b5c6-d7e8-9f0a-1b2c-3d4e5f6a7b8c': {
    title: 'Problema en el código postal de destino',
    subtitle: `${REPLACE_KEYS.USER} reportó un problema con el código postal de destino`
  },
  // Reporte de problemas
  '80e5cf5c-9041-42a6-b85c-cbeef5d87218': {
    title: 'Situación adversa reportada',
    subtitle: `${REPLACE_KEYS.USER} reportó una situación adversa en punto de origen`
  },
  '8a26df58-52b0-470c-b3b8-b14f58db9358': {
    title: 'Situación adversa reportada',
    subtitle: `${REPLACE_KEYS.USER} reportó una situación adversa en punto de destino`
  },
  '2e862cbf-95c9-4a7d-99a0-0f477e38ed3a': {
    title: 'Esperando respuesta',
    subtitle: `${REPLACE_KEYS.USER} indicó que está en espera de respuesta para continuar`
  },
  'd6cb0345-fafd-4209-b097-103175dced27': {
    title: 'Empleado no responde',
    subtitle: `${REPLACE_KEYS.USER} reportó que el empleado que entrega no responde`
  },
  'dcd62dc1-1dd0-4e65-a424-04ed932df826': {
    title: 'Empleado no responde',
    subtitle: `${REPLACE_KEYS.USER} reportó que el empleado que recibe no responde`
  },
  '935363cf-64fe-406c-939c-e592a5236fd6': {
    title: 'Empleado no entregó',
    subtitle: `${REPLACE_KEYS.USER} reportó que el empleado que entrega no cumple con la fecha estipulada`
  },
  '9a6513f9-9a96-4233-a788-63d7fb651f20': {
    title: 'Empleado no recibió',
    subtitle: `${REPLACE_KEYS.USER} reportó que el empleado que recibe no cumple con la fecha estipulada`
  },
  'e02b360f-af39-4fef-af0b-15338d899221': {
    title: 'Retraso por festivo',
    subtitle: `${REPLACE_KEYS.USER} reportó retraso por días festivos en el país`
  },
  '0d17b581-2211-43f2-9717-0bc286c9d6cb': {
    title: 'Empleado no dispuesto a entregar',
    subtitle: `${REPLACE_KEYS.USER} reportó que el empleado no tiene disposición para entregar`
  },
  'a1ef3559-aafc-44a1-ae38-2003fc925e34': {
    title: 'Reporte sin motivo especificado',
    subtitle: `${REPLACE_KEYS.USER} reportó una incidencia sin especificar la razón`
  },
  // Configuraciones
  '81fc02ee-82fa-4c44-bf2b-ee808fa37055': {
    title: 'Herramienta recibida con Wiping',
    subtitle: `${REPLACE_KEYS.USER} indicó que la herramienta llegó con Wiping a Bodegas`
  },
  '5ae716ff-395b-4e0c-a909-268fafe058ca': {
    title: 'Configuración no completada',
    subtitle: `${REPLACE_KEYS.USER} marcó la configuración como no completada`
  },
  'fef572b8-3258-4a97-8cbb-7e34feea8c66': {
    title: 'Configuración completada',
    subtitle: `${REPLACE_KEYS.USER} marcó la configuración como completada`
  },
  'f8a3c921-4d7e-4b2a-9c01-1e2f3a4b5c6d': {
    title: 'Configuración completada, pendiente de aprobación',
    subtitle: `${REPLACE_KEYS.USER} completó la configuración. Estamos esperando la aprobación del usuario`
  },
  'e7b2d814-3c6f-4a19-8d12-0f1e2d3c4b5a': {
    title: 'Configuración aprobada por el cliente',
    subtitle: `La configuración fue aprobada por ${REPLACE_KEYS.USER}`
  },
  // Operaciones
  'cdb6ec72-3ab9-4f44-9510-0a0783624344': {
    title: 'Estado del dispositivo cargado',
    subtitle: `${REPLACE_KEYS.USER} cargó el documento del estado del dispositivo (DSN)`
  },
  'e8d7c6b5-a493-4f2e-8d1c-0b9a8f7e6d5c': {
    title: 'Estado del dispositivo actualizado',
    subtitle: `${REPLACE_KEYS.USER} actualizó el estado de la herramienta ${REPLACE_KEYS.NEW_PRODUCT_SERIAL} (DSN)`
  },
  '31231a8b-c98d-4a1b-8502-135b5750bbde': {
    title: 'Documento de entrega cargado',
    subtitle: `Se subió el documento de entrega del dispositivo por ${REPLACE_KEYS.USER}`
  },
  'c2209282-7469-4977-962b-e48894f01bd9': {
    title: 'SKU actualizado',
    subtitle: `El SKU de la herramienta fue actualizado por ${REPLACE_KEYS.USER}`
  },
  'a7f3c9e2-8b4d-4c1a-9e6f-2d8a5c3b0f7e': {
    title: 'Documento de recibido cargado',
    subtitle: `Se subió el documento de recibido del dispositivo por ${REPLACE_KEYS.USER}`
  },
  'd3c4b5a6-9708-4e9f-a0b1-2c3d4e5f6a7b': {
    title: 'Herramienta reemplazada',
    subtitle: `La herramienta con número serial ${REPLACE_KEYS.OLD_PRODUCT_SERIAL} fue reemplazada por la herramienta con número serial ${REPLACE_KEYS.NEW_PRODUCT_SERIAL} por ${REPLACE_KEYS.USER}`
  },
  'b7e4f2a1-9c3d-4e8f-a1b2-c3d4e5f67890': {
    title: 'Reporte cerrado',
    subtitle: `${REPLACE_KEYS.USER} cerró el reporte ${REPLACE_KEYS.REPORT_NAME}`
  },
  // ----- Orders -----
  // Actualizaciones de estado
  '3766714a-85b0-4324-b02a-597c88e394dd': {
    title: 'Orden solicitada',
    subtitle: `Orden solicitada por ${REPLACE_KEYS.USER} desde Dash`
  },
  '1adfe47e-fb17-4cbd-a47f-bee1054d8f70': {
    title: 'Orden cargada masivamente',
    subtitle: `Orden agregada por cargue masivo por ${REPLACE_KEYS.USER}`
  },
  'de6f3a9a-50e6-43b9-94f1-dcd9bebd59bf': {
    title: 'Orden confirmada',
    subtitle: 'Orden confirmada automáticamente por Stripe'
  },
  '1d0d846b-f72b-49ba-95a1-1982bb9bc9a1': {
    title: 'Orden confirmada',
    subtitle: `${REPLACE_KEYS.USER} ha confirmado la orden`
  },
  'cf6995a2-5546-4c88-8da5-2833ce83417c': {
    title: 'Orden activa',
    subtitle: `Envío a ${REPLACE_KEYS.DESTINATION} ha pasado a proceso de entrega`
  },
  '66f52dae-704b-4332-b0f1-924e13455d69': {
    title: 'Orden cancelada',
    subtitle: `La orden fue cancelada por ${REPLACE_KEYS.USER}`
  },
  '15851e4c-9c0c-44d1-9285-8ea892c1f9ae': {
    title: 'Orden entregada',
    subtitle: 'Todos los envíos fueron marcados como entregados'
  },
  '3db5d26a-4d2a-48ce-a2d5-42a522002256': {
    title: 'Orden atrasada',
    subtitle: `Envío a ${REPLACE_KEYS.DESTINATION} ha superado la fecha estimada de entrega. CTA: Revisar envío`
  },
  'a8f4e2b9-1c5d-4f7e-9a8b-3d2f1e4c6b7a': {
    title: 'Envío se ha separado',
    subtitle: `${REPLACE_KEYS.USER} separó el envío a ${REPLACE_KEYS.DESTINATION}`
  },
  '327c0026-c75d-4188-abb5-8213ee1a736e': {
    title: 'Envío entregado',
    subtitle: `Envío ha pasado a entregado por ${REPLACE_KEYS.USER}`
  },
  // Pagos y Facturación
  '1ea37d24-a13b-48b2-8565-420b932ef66a': {
    title: 'Fecha de pago actualizada',
    subtitle: `Fecha de pago modificada por ${REPLACE_KEYS.USER}`
  },
  '3f7803eb-4356-4969-bc23-c8762574922b': {
    title: 'Acuerdo de pago creado',
    subtitle: `Acuerdo de pago agregado por ${REPLACE_KEYS.USER}`
  },
  '9c13a2d9-0eda-47b9-805e-d3073ad6d1f0': {
    title: 'Pago recibido (enlace Stripe)',
    subtitle: 'Pago realizado a través de enlace de Stripe'
  },
  '4109f2a1-d829-4af1-bdb1-4a5738bada80': {
    title: 'Pago confirmado manualmente',
    subtitle: `Pago confirmado manualmente por ${REPLACE_KEYS.USER}`
  },
  'bf60015d-322b-4b53-ae11-0a23d195a507': {
    title: 'Link de pago agregado',
    subtitle: `Link de pago agregado manualmente por ${REPLACE_KEYS.USER}`
  },
  'd64a19a0-6d7b-45df-a336-b5d3272a1d56': {
    title: 'Comprobante cargado',
    subtitle: `Comprobante de pago agregado por ${REPLACE_KEYS.USER}`
  },
  'f0c607b3-60ec-4049-b524-d70865b12eb3': {
    title: 'Link de pago generado',
    subtitle: 'Stripe generó automáticamente el link de pago'
  },
  'e7658a77-9a38-47dc-8544-a90a9b833c5d': {
    title: 'Factura actualizada',
    subtitle: `Factura modificada por ${REPLACE_KEYS.USER}`
  },
  '5ee9a5e9-267e-46b4-9801-b5a3f6a5b0a1': {
    title: 'Factura cargada',
    subtitle: `Factura agregada a la orden por ${REPLACE_KEYS.USER}`
  },
  '1387e236-8f9a-4de2-a3c7-2a451ae43d79': {
    title: 'Orden confirmada',
    subtitle: 'Orden confirmada automáticamente por Stripe'
  },
  'f8a3b2c1-4d5e-6f7a-8b9c-0d1e2f3a4b5c': {
    title: 'Orden confirmada',
    subtitle: 'Orden confirmada automáticamente con Credito Bord'
  },
  // Reporte de información
  'fa152280-d437-44bc-b794-e6b1241c6381': {
    title: 'Reporte de información incorrecta',
    subtitle: `${REPLACE_KEYS.USER} reportó un problema con la dirección de entrega`
  },
  'f4001f0e-cb8a-4adc-8fbf-871d0822f29d': {
    title: 'Reporte de información incorrecta',
    subtitle: `${REPLACE_KEYS.USER} reportó un número telefónico inválido`
  },
  'b3c4d5e6-f7a8-9b0c-1d2e-3f4a5b6c7d8e': {
    title: 'Reporte de información incorrecta',
    subtitle: `${REPLACE_KEYS.USER} reportó un problema con la ciudad de entrega`
  },
  'c4d5e6f7-a8b9-0c1d-2e3f-4a5b6c7d8e9f': {
    title: 'Reporte de información incorrecta',
    subtitle: `${REPLACE_KEYS.USER} reportó un problema con las indicaciones de entrega`
  },
  'd5e6f7a8-b9c0-1d2e-3f4a-5b6c7d8e9f0a': {
    title: 'Reporte de información incorrecta',
    subtitle: `${REPLACE_KEYS.USER} reportó un problema con el código postal de entrega`
  },
  'a6dd4cbb-3d3c-47a3-b859-ae591c063b53': {
    title: 'Información actualizada por el usuario',
    subtitle: `${REPLACE_KEYS.USER} modificó los datos del envío`
  },
  'a1b2c3d4-e5f6-7890-abcd-ef1234567890': {
    title: 'Información actualizada',
    subtitle: `${REPLACE_KEYS.USER} modificó los datos del envío`
  },
  '9bdaba0b-18e2-4499-838e-60cb9bcf2924': {
    title: 'Información corregida por el usuario',
    subtitle: `${REPLACE_KEYS.USER} corrigió los datos reportados por operaciones`
  },
  '3417707a-b9a7-445e-a4b6-d8c67c257fd2': {
    title: 'Sin respuesta de operaciones',
    subtitle: `Han pasado 24 horas sin validación de ${REPLACE_KEYS.USER} tras los cambios del cliente`
  },
  '7953723b-157d-436d-ae30-5280eeeb265f': {
    title: 'Sin respuesta del usuario',
    subtitle: `Han pasado 24 horas sin respuesta de ${REPLACE_KEYS.USER} a la corrección solicitada`
  },
  // Configuraciones
  'c75bbe61-97c8-4f1a-bd9c-51f45661edce': {
    title: 'Configuración no completada',
    subtitle: `${REPLACE_KEYS.USER} marcó la configuración como no completada`
  },
  '7372e03f-171e-4e79-9edd-1f4b87a142d0': {
    title: 'Configuración completada',
    subtitle: `${REPLACE_KEYS.USER} marcó la configuración como completada`
  },
  'a1b2c3d4-e5f6-4789-a012-3456789abcde': {
    title: 'Configuración completada, pendiente de aprobación',
    subtitle: `${REPLACE_KEYS.USER} completó la configuración. Estamos esperando la aprobación del usuario.`
  },
  'b2c3d4e5-f6a7-4890-b123-456789abcdef': {
    title: 'Configuración aprobada por el cliente',
    subtitle: `La configuración fue aprobada por ${REPLACE_KEYS.USER}.`
  },
  // Operaciones
  '6e7b028f-9223-4fb2-b394-d1e13e820528': {
    title: 'Destino actualizado a Bodega',
    subtitle: `El destino del envío fue cambiado a Bodegas por ${REPLACE_KEYS.USER}`
  },
  'c4a611d3-c463-447e-bf20-f7fbc28a05f4': {
    title: 'SKU actualizado',
    subtitle: `El SKU de la herramienta fue modificado por ${REPLACE_KEYS.USER}`
  },
  'c3d4e5f6-a7b8-4901-a234-56789abcdef0': {
    title: 'Fechas actualizadas',
    subtitle: `${REPLACE_KEYS.USER} actualizó las fechas del envío a ${REPLACE_KEYS.DESTINATION}`
  },
  'a1f4b8e2-0d3c-4f5e-9a7b-2c6d4e8f1a3b': {
    title: 'Envío en preparación',
    subtitle: `Envío ha pasado a preparación por ${REPLACE_KEYS.USER}`
  },
  'b2e5c9f3-1d4d-4e6f-8a9b-3c7d5e9f2a4c': {
    title: 'Envío en tránsito a bodega',
    subtitle: `Envío ha pasado a tránsito a bodega por ${REPLACE_KEYS.USER}`
  },
  'c3f6daf4-2e5e-4f7e-8a9b-4c8d6f0a3b5d': {
    title: 'Envío llegó a bodega',
    subtitle: `Envío ha pasado a en bodega por ${REPLACE_KEYS.USER}`
  },
  'd4f7ebf5-3f6f-4f8e-9b0c-5d9e7f1b4c6e': {
    title: 'Envío en tránsito',
    subtitle: `Envío ha pasado a tránsito a destino por ${REPLACE_KEYS.USER}`
  }
} as const;

export const LOGISTIC_SERVICE_HISTORY_DSN_DEVICE_STATUS_EVENT_UUID = 'cdb6ec72-3ab9-4f44-9510-0a0783624344';
